import apiClient from '../../Services/ApiClient';
import React, { useState } from 'react';
import { useEffectAsync } from '../../helpers';

interface Props {
	workplaceId: string;
	userId?: string;
	patientId?: string;
}

enum CreateCaseTarget {
	WORKPLACE_MEMBER = 1,
	WORKPLACE = 9,
}

const UserRelationButton: React.FC<Props> = ({
	workplaceId,
	userId,
	patientId,
}) => {
	const [active, setActive] = useState(false);

	useEffectAsync(async () => {
		const { data } = await apiClient.get(
			`/user-relations?relationUserId=${userId}&workplaceId=${workplaceId}&userId=${patientId}`,
		);

		if (data.length) {
			setActive(data[0].id);
		}
	}, []);

	const handleClick = async () => {
		const queryArgs = {
			relationUserId: userId ? userId : null,
			type: userId
				? CreateCaseTarget.WORKPLACE_MEMBER
				: CreateCaseTarget.WORKPLACE,
			workplaceId,
			userId: patientId,
		};
		if (active) {
			const { data } = await apiClient.delete(
				`/user-relations/${active}`,
				queryArgs,
			);

			if (data.ok) {
				setActive(false);
			}
		} else {
			const { data } = await apiClient.post('/user-relations', queryArgs);

			if (data.id) {
				setActive(data.id);
			}
		}
	};

	return (
		<a onClick={handleClick}>
			<div
				className={`user-card-with-favorite__icon-wrapper ${
					active ? 'active' : ''
				}`}>
				<i className='fa-solid fa-heart' />
			</div>
		</a>
	);
};

export default UserRelationButton;
